/**
 * PC — Currency Display (pc-currency.js)
 * 汇率来源：open.er-api.com
 */

(function () {

  var LOCALE_CURRENCY = {
    "ar":    "AED",
    "de":    "EUR",
    "en-GB": "GBP",
    "es":    "EUR",
    "fr":    "EUR",
    "he":    "ILS",
    "it":    "EUR",
    "ja":    "JPY",
    "pt-PT": "EUR",
    "ru":    "RUB",
    "zh-TW": "TWD"
  };

  var PD_NOTE = {
    "ar":    "سعر USD · سعر الصرف تقريبي",
    "de":    "USD-Preis · Kurs ca.",
    "en-GB": "USD price · rate approx.",
    "es":    "Precio USD · cambio referencial",
    "fr":    "Prix USD · taux indicatif",
    "he":    "מחיר USD · שער משוער",
    "it":    "Prezzo USD · cambio indicativo",
    "ja":    "USD定価 · 為替レートにより変動します",
    "pt-PT": "Preço USD · câmbio indicativo",
    "ru":    "Цена USD · ориентировочный курс",
    "zh-TW": "美元定價 · 匯率僅供參考"
  };
    var DISCLAIMER = {
    "ar":    "سعر USD · سعر الصرف تقريبي",
    "de":    "USD-Preis · Kurs ca.",
    "en-GB": "USD price · rate approx.",
    "es":    "Precio USD · cambio referencial",
    "fr":    "Prix USD · taux indicatif",
    "he":    "מחיר USD · שער משוער",
    "it":    "Prezzo USD · cambio indicativo",
    "ja":    "USD定価 · 為替レートにより変動します",
    "pt-PT": "Preço USD · câmbio indicativo",
    "ru":    "Цена USD · ориентировочный курс",
    "zh-TW": "美元定價 · 匯率僅供參考"
  };

  var CURRENCY_FORMAT = {
    "AED": { symbol: "AED ", decimals: 2 },
    "EUR": { symbol: "€",   decimals: 2 },
    "GBP": { symbol: "£",   decimals: 2 },
    "ILS": { symbol: "₪",   decimals: 2 },
    "JPY": { symbol: "¥",   decimals: 0 },
    "RUB": { symbol: "₽",   decimals: 0 },
    "TWD": { symbol: "NT$", decimals: 0 }
  };

  var FALLBACK_RATES = {
    "AED": 3.67,
    "EUR": 0.92,
    "GBP": 0.79,
    "ILS": 3.75,
    "JPY": 149.0,
    "RUB": 90.0,
    "TWD": 32.0
  };

  /* ── locale 检测 ── */
  function normalizeLocale(code) {
    var lower = code.toLowerCase();
    if (lower === "en-gb")                   return "en-GB";
    if (lower === "pt" || lower === "pt-pt") return "pt-PT";
    if (lower.startsWith("zh"))              return "zh-TW";
    return code.split("-")[0].toLowerCase();
  }

  function getLocale() {
    var dl = document.documentElement.dataset.locale;
    if (dl) return normalizeLocale(dl);
    var lang = document.documentElement.lang;
    if (lang) return normalizeLocale(lang);
    var m = window.location.pathname.match(/^\/([a-z]{2}(?:-[A-Za-z]{2})?)\//i);
    if (m) return normalizeLocale(m[1]);
    return "en";
  }

  /* ── 汇率获取 ── */
  function fetchRate(targetCurrency, callback) {
    var cacheKey = "pc_fx2_" + targetCurrency;
    var cached   = sessionStorage.getItem(cacheKey);
    if (cached) { callback(parseFloat(cached)); return; }

    fetch("https://open.er-api.com/v6/latest/USD")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var rate = data.rates && data.rates[targetCurrency];
        if (rate) {
          sessionStorage.setItem(cacheKey, rate);
          callback(rate);
        } else {
          callback(FALLBACK_RATES[targetCurrency]);
        }
      })
      .catch(function () {
        callback(FALLBACK_RATES[targetCurrency]);
      });
  }

  /* ── 格式化 ── */
  function formatAmount(amount, currency) {
    var fmt = CURRENCY_FORMAT[currency];
    if (!fmt) return "";
    var value = amount.toFixed(fmt.decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fmt.symbol + value;
  }

  /* ── 注入 ── */
  function injectConvertedPrices(rate, currency, locale) {
    var disclaimer = DISCLAIMER[locale] || "Reference rate · Billed in USD";
    var parts = disclaimer.split("·").map(function (s) { return s.trim(); });
    var line1 = parts[0] || "";
    var line2 = parts[1] || "";

    var priceRows = document.querySelectorAll(".pc-cl-card__price-row, .pc-pd-price-row, .pc-pd-rcard__price");
    priceRows.forEach(function (row) {
      var isPd = row.classList.contains("pc-pd-price-row");
      if (row.dataset.pcInjected) return;
      row.dataset.pcInjected = "1";

      var priceEl = row.querySelector(".pc-cl-card__price, .pc-pd-price, .pc-pd-rcard__price-main");
      if (!priceEl) return;

      var usd = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ""));
      if (!usd) return;

      var converted = formatAmount(usd * rate * 1.04, currency);

      var wrap = document.createElement("div");
      wrap.className = "pc-currency-wrap";

      var isRcard = !!row.closest('.pc-pd-rcard');
      if (isPd) {
        var inlineEl = document.createElement("span");
        inlineEl.className = "pc-currency-inline";
        inlineEl.textContent = "(" + converted + ")";
        priceEl.insertAdjacentElement("afterend", inlineEl);

      } else {
        var priceLine = document.createElement("div");
        priceLine.className = "pc-currency-price-line";
        while (row.firstChild) { priceLine.appendChild(row.firstChild); }
        var inlineEl = document.createElement("span");
        inlineEl.className = "pc-currency-inline";
        inlineEl.textContent = "(" + converted + ")";
        priceLine.appendChild(inlineEl);
        wrap.appendChild(priceLine);
      }

      if (isPd) {
        var pdText = PD_NOTE[locale] || "Priced in USD · Bracketed rate for reference only";
        var pdParts = pdText.split("·").map(function(s){ return s.trim(); });
        var noteEl = document.createElement("div");
        noteEl.className = "pc-currency-note";
        noteEl.textContent = pdParts.join(" · ");
        wrap.appendChild(noteEl);
      } else {
       [line1, line2].filter(Boolean).forEach(function(text) {
        var noteEl = document.createElement("div");
        noteEl.className = "pc-currency-note";
        noteEl.textContent = text;
        wrap.appendChild(noteEl);
      });
      }

      row.appendChild(wrap);
    });
  }

  /* ── CSS ── */
  function injectStyles() {
    var style = document.createElement("style");
    style.textContent = [
      ".pc-pd-rcard__price-main {",
      "  font-family: 'Cormorant Garamond', serif !important;",
      "  font-size: 24px !important;",
      "  font-weight: 300 !important;",
      "  letter-spacing: -.01em !important;",
      "  color: var(--brown-dark) !important;",
      "}",
      ".pc-cl-card__price-row {",
      "  display: flex !important;",
      "  align-items: flex-start !important;",
      "  justify-content: space-between !important;",
      "  flex-wrap: nowrap !important;",
      "  gap: 8px !important;",
      "}",
      ".pc-currency-wrap {",
      "  display: flex !important;",
      "  flex-direction: column !important;",
      "  align-items: flex-end !important;",
      "  gap: 1px !important;",
      "  margin-left: auto !important;",
      "}",
      ".pc-currency-price-line {",
      "  display: flex !important;",
      "  align-items: baseline !important;",
      "  flex-wrap: nowrap !important;",
      "  gap: 4px !important;",
      "  white-space: nowrap !important;",
      "}",
      ".pc-currency-inline {",
      "  font-family: 'Cormorant Garamond', serif !important;",
      "  font-size: 0.88em !important;",
      "  font-weight: 400 !important;",
      "  color: var(--mid, #8C6B5A) !important;",
      "  letter-spacing: .01em !important;",
      "  opacity: 0.9 !important;",
      "  white-space: nowrap !important;",
      "}",
      ".pc-pd-price-row .pc-currency-inline {",
      "  font-size: var(--price-fs, 38px) !important;",
      "  font-weight: 300 !important;",
      "  color: var(--brown-dark, #4A3228) !important;",
      "  opacity: 1 !important;",
      "  letter-spacing: 0 !important;",
      "}",
".pc-currency-note {",
      "  display: block !important;",
      "  font-family: 'Jost', sans-serif !important;",
      "  font-size: 10px !important;",
      "  letter-spacing: .1em !important;",
      "  color: rgba(0,0,0,0.5) !important;",
      "  text-transform: uppercase !important;",
      "  line-height: 1.5 !important;",
      "  text-align: right !important;",
      "  white-space: nowrap !important;",
      "  overflow: hidden !important;",
      "  text-overflow: ellipsis !important;",
      "  max-width: 200px !important;",
      "}",
      ".pc-pd-price-row .pc-currency-note {",
      "  font-size: 12px !important;",
      "  font-weight: 400 !important;",
      "  letter-spacing: .12em !important;",
      "  color: var(--mid, #8C6B5A) !important;",
      "  text-align: left !important;",
      "  max-width: none !important;",
      "  overflow: visible !important;",
      "  text-overflow: clip !important;",
      "  white-space: nowrap !important;",
      "}",
      ".pc-pd-price-row .pc-currency-wrap {",
      "  align-items: flex-start !important;",
      "  margin-left: 0 !important;",
      "}",
    ].join("\n");
    document.head.appendChild(style);
  }

  /* ── 主入口 ── */
  function init() {
    var locale   = getLocale();
    var currency = LOCALE_CURRENCY[locale];
    if (!currency) return;

    injectStyles();
    fetchRate(currency, function (rate) {
      if (!rate) return;
      injectConvertedPrices(rate, currency, locale);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();